<template>
  <div>
    <!-- URGENCY BANNER (below navbar) -->
    <div class="bg-gradient-to-r from-red-600 via-red-500 to-orange-500 text-white py-3 px-4 shadow-lg">
      <div class="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-center">
        <div class="flex items-center gap-2 animate-pulse">
          <span class="text-2xl">🔥</span>
          <span class="font-bold text-sm sm:text-base">ULTIMI 3 POSTI DISPONIBILI!</span>
        </div>
        <div class="hidden sm:block w-px h-6 bg-white/30"></div>
        <div class="flex items-center gap-3">
          <span class="text-sm font-medium">Offerta scade tra:</span>
          <div class="flex gap-1">
            <div class="bg-white/20 rounded px-2 py-1 text-center min-w-[40px]">
              <div class="text-lg font-bold leading-none">{{ countdown.days }}</div>
              <div class="text-[10px] uppercase">giorni</div>
            </div>
            <div class="bg-white/20 rounded px-2 py-1 text-center min-w-[40px]">
              <div class="text-lg font-bold leading-none">{{ countdown.hours }}</div>
              <div class="text-[10px] uppercase">ore</div>
            </div>
            <div class="bg-white/20 rounded px-2 py-1 text-center min-w-[40px]">
              <div class="text-lg font-bold leading-none">{{ countdown.minutes }}</div>
              <div class="text-[10px] uppercase">min</div>
            </div>
            <div class="bg-white/20 rounded px-2 py-1 text-center min-w-[40px]">
              <div class="text-lg font-bold leading-none">{{ countdown.seconds }}</div>
              <div class="text-[10px] uppercase">sec</div>
            </div>
          </div>
        </div>
        <router-link to="/contact" class="bg-white text-red-600 px-4 py-1.5 rounded-full font-bold text-sm hover:bg-yellow-300 transition-colors shadow-lg">
          BLOCCA IL TUO POSTO →
        </router-link>
      </div>
    </div>

    <!-- Hero Section -->
    <section class="relative overflow-hidden py-20 sm:py-32 min-h-[90vh] flex items-center">
      <!-- Modern Animated Background - Healthcare Theme -->
      <div class="absolute inset-0 bg-gradient-to-br from-teal-50 via-white to-cyan-50"></div>
      
      <!-- Animated gradient overlay -->
      <div class="absolute inset-0 bg-gradient-to-br from-teal-500/5 via-transparent to-cyan-500/5 animate-gradient"></div>
      
      <!-- Animated decorative elements -->
      <div class="absolute inset-0 overflow-hidden">
        <!-- Animated grid pattern -->
        <div class="absolute inset-0 opacity-[0.03] animate-grid" style="background-image: linear-gradient(to right, #0d9488 1px, transparent 1px), linear-gradient(to bottom, #0d9488 1px, transparent 1px); background-size: 50px 50px;"></div>
        
        <!-- Floating orbs -->
        <div class="absolute top-20 right-1/4 w-72 h-72 bg-teal-400/20 rounded-full blur-3xl animate-float"></div>
        <div class="absolute bottom-20 left-1/4 w-96 h-96 bg-cyan-400/15 rounded-full blur-3xl animate-float-delayed"></div>
      </div>

      <div class="container mx-auto px-4 relative z-10">
        <div class="max-w-5xl mx-auto text-center">
          <!-- Special Pricing Badge -->
          <div class="inline-flex flex-col sm:flex-row items-center gap-2 sm:gap-4 mb-6">
            <div class="inline-flex items-center rounded-full bg-gradient-to-r from-red-600 to-red-500 text-white px-5 py-2 text-sm font-bold shadow-lg animate-pulse">
              <span class="flex h-2 w-2 rounded-full bg-white mr-2 animate-ping"></span>
              🔥 ULTIMI 3 POSTI!
            </div>
            <div class="inline-flex items-center rounded-full bg-yellow-400 text-red-700 px-4 py-2 text-sm font-bold shadow-lg">
              ⏰ Scade il 31.12.2025
            </div>
          </div>
          
          <!-- Main Headline with Gradient -->
          <h1 class="text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.1] mb-6">
            <span class="bg-gradient-to-r from-gray-900 via-teal-600 to-cyan-600 bg-clip-text text-transparent">
              Sito Web + Gestionale
            </span>
            <span class="block bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent mt-2">
              per Fisioterapisti
            </span>
          </h1>
          
          <!-- Description -->
          <p class="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed mb-8 font-medium">
            La soluzione digitale completa per il tuo studio di fisioterapia. Sito web professionale con sistema gestionale integrato per appuntamenti, pazienti e fatturazione.
          </p>

          <!-- Pricing Highlight with URGENCY -->
          <div class="relative bg-gradient-to-r from-teal-50 to-cyan-50 border-2 border-red-300 rounded-2xl p-6 max-w-2xl mx-auto mb-8 shadow-lg overflow-hidden">
            <!-- Corner ribbon -->
            <div class="absolute -right-12 top-6 rotate-45 bg-red-500 text-white text-xs font-bold py-1 px-12 shadow-lg">
              -40% SCONTO
            </div>
            
            <!-- Spots remaining -->
            <div class="flex items-center justify-center gap-2 mb-4">
              <div class="flex">
                <div class="w-3 h-3 rounded-full bg-red-500 animate-pulse"></div>
                <div class="w-3 h-3 rounded-full bg-red-500 animate-pulse -ml-1"></div>
                <div class="w-3 h-3 rounded-full bg-red-500 animate-pulse -ml-1"></div>
                <div class="w-3 h-3 rounded-full bg-gray-300 -ml-1"></div>
                <div class="w-3 h-3 rounded-full bg-gray-300 -ml-1"></div>
              </div>
              <span class="text-red-600 font-bold text-sm">Solo 3 posti rimasti a questo prezzo!</span>
            </div>
            
            <div class="flex flex-col md:flex-row items-center justify-center gap-6">
              <div class="text-center">
                <div class="text-lg text-gray-400 line-through">5'000 CHF</div>
                <div class="text-4xl md:text-5xl font-extrabold text-teal-600">3'000 CHF</div>
                <div class="text-sm text-gray-600 font-semibold">una tantum</div>
              </div>
              <div class="text-3xl text-gray-400 hidden md:block">+</div>
              <div class="text-center">
                <div class="text-lg text-gray-400 line-through">25 CHF/mese</div>
                <div class="text-4xl md:text-5xl font-extrabold text-cyan-600">10 CHF</div>
                <div class="text-sm text-gray-600 font-semibold">al mese (hosting + manutenzione)</div>
              </div>
            </div>
            
            <div class="mt-4 text-center">
              <span class="inline-block bg-yellow-100 text-yellow-800 text-xs font-bold px-3 py-1 rounded-full border border-yellow-300">
                💰 Risparmi 2'180 CHF rispetto al prezzo normale!
              </span>
            </div>
          </div>

          <!-- Key Benefits Pills -->
          <div class="mt-8 flex flex-wrap justify-center gap-3 mb-8">
            <div class="px-5 py-2.5 bg-white/90 backdrop-blur-sm rounded-full border-2 border-teal-200 shadow-md hover:shadow-lg text-sm font-semibold text-gray-700 transition-all duration-300 transform hover:scale-105">
              <Check class="inline h-4 w-4 text-green-500 mr-1" />
              Sito Web Professionale
            </div>
            <div class="px-5 py-2.5 bg-white/90 backdrop-blur-sm rounded-full border-2 border-teal-200 shadow-md hover:shadow-lg text-sm font-semibold text-gray-700 transition-all duration-300 transform hover:scale-105">
              <Check class="inline h-4 w-4 text-green-500 mr-1" />
              Gestionale Appuntamenti
            </div>
            <div class="px-5 py-2.5 bg-white/90 backdrop-blur-sm rounded-full border-2 border-teal-200 shadow-md hover:shadow-lg text-sm font-semibold text-gray-700 transition-all duration-300 transform hover:scale-105">
              <Check class="inline h-4 w-4 text-green-500 mr-1" />
              Schede Pazienti
            </div>
            <div class="px-5 py-2.5 bg-white/90 backdrop-blur-sm rounded-full border-2 border-teal-200 shadow-md hover:shadow-lg text-sm font-semibold text-gray-700 transition-all duration-300 transform hover:scale-105">
              <Check class="inline h-4 w-4 text-green-500 mr-1" />
              Fatturazione Integrata
            </div>
          </div>
          
          <!-- Enhanced CTAs with URGENCY -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <router-link 
              to="/contact" 
              class="group relative h-16 px-10 bg-gradient-to-r from-red-500 via-red-600 to-orange-500 hover:from-red-600 hover:via-red-700 hover:to-orange-600 text-white rounded-2xl flex items-center justify-center font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-2xl hover:shadow-red-500/50 animate-bounce-subtle"
            >
              <span class="absolute inset-0 rounded-2xl bg-gradient-to-r from-red-400 to-orange-400 opacity-0 group-hover:opacity-100 blur-xl transition-opacity"></span>
              <Rocket class="mr-3 h-6 w-6 relative z-10" />
              <span class="relative z-10">🔥 BLOCCA IL TUO POSTO ORA</span>
            </router-link>
            
            <router-link 
              to="/contact" 
              class="h-16 px-8 border-3 border-red-400 hover:border-red-500 text-red-600 hover:text-red-700 rounded-2xl flex items-center justify-center font-bold text-lg transition-all duration-300 transform hover:scale-105 bg-white shadow-lg hover:shadow-xl"
            >
              <Phone class="mr-2 h-5 w-5" />
              Contattaci Ora
            </router-link>
          </div>
          
          <!-- Urgency notice -->
          <div class="bg-yellow-100 border-2 border-yellow-300 rounded-xl p-3 max-w-md mx-auto mb-6">
            <p class="text-yellow-800 text-sm font-bold flex items-center justify-center gap-2">
              <AlertTriangle class="h-4 w-4" />
              Solo 3 posti rimasti a questo prezzo!
            </p>
          </div>

          <!-- Social Proof -->
          <div class="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-600">
            <div class="flex items-center bg-white/80 backdrop-blur-sm rounded-full px-4 py-2 border border-gray-200 shadow-sm">
              <Star class="h-5 w-5 text-yellow-400 mr-1 fill-yellow-400" />
              <span class="font-bold">4.9/5</span>
              <span class="ml-1">Clienti Soddisfatti</span>
            </div>
            <div class="flex items-center bg-white/80 backdrop-blur-sm rounded-full px-4 py-2 border border-gray-200 shadow-sm">
              <Heart class="h-5 w-5 text-red-500 mr-1" />
              <span class="font-semibold">Specializzati in Healthcare</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- What's Included Section -->
    <section class="relative py-20 bg-gradient-to-br from-white via-teal-50/30 to-white overflow-hidden">
      <div class="absolute inset-0">
        <div class="absolute top-0 right-0 w-64 h-64 bg-teal-400/10 rounded-full blur-3xl"></div>
        <div class="absolute bottom-0 left-0 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl"></div>
      </div>
      
      <div class="container mx-auto px-4 relative z-10">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold mb-6">
            <span class="bg-gradient-to-r from-teal-600 via-teal-500 to-cyan-600 bg-clip-text text-transparent">
              Cosa Include il Pacchetto
            </span>
          </h2>
          <p class="text-xl text-gray-600 max-w-3xl mx-auto">
            Una soluzione completa per digitalizzare il tuo studio di fisioterapia
          </p>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <!-- Website Features -->
          <div class="bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-teal-200 shadow-xl">
            <div class="flex items-center gap-4 mb-6">
              <div class="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg">
                <Globe class="h-7 w-7 text-white" />
              </div>
              <h3 class="text-2xl font-bold text-gray-800">Sito Web Professionale</h3>
            </div>
            <div class="space-y-4">
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">Design Moderno e Responsive</p>
                  <p class="text-sm text-gray-600">Perfetto su desktop, tablet e smartphone</p>
                </div>
              </div>
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">Presentazione Servizi</p>
                  <p class="text-sm text-gray-600">Pagine dedicate per ogni trattamento offerto</p>
                </div>
              </div>
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">Modulo Contatto</p>
                  <p class="text-sm text-gray-600">Form per richieste e prenotazioni online</p>
                </div>
              </div>
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">SEO Ottimizzato</p>
                  <p class="text-sm text-gray-600">Trovati facilmente su Google nella tua zona</p>
                </div>
              </div>
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">Mappa e Indicazioni</p>
                  <p class="text-sm text-gray-600">Google Maps integrato per trovare il tuo studio</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Management System Features -->
          <div class="bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-cyan-200 shadow-xl">
            <div class="flex items-center gap-4 mb-6">
              <div class="w-14 h-14 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-xl flex items-center justify-center shadow-lg">
                <Settings class="h-7 w-7 text-white" />
              </div>
              <h3 class="text-2xl font-bold text-gray-800">Sistema Gestionale</h3>
            </div>
            <div class="space-y-4">
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">Agenda Appuntamenti</p>
                  <p class="text-sm text-gray-600">Calendario digitale con promemoria automatici</p>
                </div>
              </div>
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">Schede Pazienti</p>
                  <p class="text-sm text-gray-600">Anagrafica completa con storico trattamenti</p>
                </div>
              </div>
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">Fatturazione</p>
                  <p class="text-sm text-gray-600">Emissione fatture e gestione pagamenti</p>
                </div>
              </div>
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">Report e Statistiche</p>
                  <p class="text-sm text-gray-600">Analisi appuntamenti e fatturato</p>
                </div>
              </div>
              <div class="flex items-start space-x-3">
                <Check class="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p class="font-semibold text-gray-800">Notifiche SMS/Email</p>
                  <p class="text-sm text-gray-600">Promemoria automatici per i pazienti</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Pricing Section -->
    <section class="relative py-20 bg-gradient-to-br from-teal-600 via-teal-700 to-cyan-700 overflow-hidden">
      <div class="absolute inset-0">
        <div class="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        <div class="absolute bottom-0 left-0 w-96 h-96 bg-cyan-400/10 rounded-full blur-3xl"></div>
      </div>
      
      <div class="container mx-auto px-4 relative z-10">
        <div class="text-center mb-12">
          <div class="inline-flex items-center rounded-full bg-red-500/30 border border-red-300/50 text-white px-4 py-2 text-sm font-bold mb-4">
            ⏰ Offerta valida fino al 31 Dicembre 2025
          </div>
          <h2 class="text-3xl md:text-4xl font-bold text-white mb-4">
            Un Prezzo Semplice e Trasparente
          </h2>
          <p class="text-xl text-white/90 max-w-2xl mx-auto">
            Nessun costo nascosto. Tutto incluso nel pacchetto.
          </p>
        </div>

        <div class="max-w-4xl mx-auto">
          <div class="relative bg-white/95 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-2xl overflow-hidden">
            <!-- Animated border -->
            <div class="absolute inset-0 rounded-3xl border-4 border-red-400 animate-pulse"></div>
            
            <!-- Corner ribbon -->
            <div class="absolute -right-14 top-8 rotate-45 bg-red-500 text-white text-sm font-bold py-2 px-16 shadow-lg z-10">
              🔥 ULTIMI 3 POSTI
            </div>
            
            <div class="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <!-- Price Display -->
              <div class="text-center md:text-left">
                <div class="mb-6">
                  <span class="text-gray-600 text-lg font-semibold">Una Tantum</span>
                  <div class="text-2xl text-gray-400 line-through">5'000 CHF</div>
                  <div class="text-5xl md:text-6xl font-extrabold text-teal-600">3'000 CHF</div>
                  <p class="text-gray-500 mt-2">Sito web + Gestionale completo</p>
                  <span class="inline-block mt-2 bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded">RISPARMI 2'000 CHF</span>
                </div>
                <div class="border-t border-gray-200 pt-6">
                  <span class="text-gray-600 text-lg font-semibold">Mensile</span>
                  <div class="text-xl text-gray-400 line-through">25 CHF/mese</div>
                  <div class="text-4xl md:text-5xl font-extrabold text-cyan-600">10 CHF</div>
                  <p class="text-gray-500 mt-2">Hosting + Manutenzione + Supporto</p>
                  <span class="inline-block mt-2 bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded">-60% SCONTO</span>
                </div>
              </div>

              <!-- Included Features -->
              <div class="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-6 border border-teal-200">
                <h4 class="font-bold text-gray-800 mb-4 text-lg">Cosa è incluso:</h4>
                <ul class="space-y-3">
                  <li class="flex items-center text-gray-700">
                    <Check class="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                    <span>Sito web professionale</span>
                  </li>
                  <li class="flex items-center text-gray-700">
                    <Check class="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                    <span>Sistema gestionale completo</span>
                  </li>
                  <li class="flex items-center text-gray-700">
                    <Check class="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                    <span>Hosting svizzero sicuro</span>
                  </li>
                  <li class="flex items-center text-gray-700">
                    <Check class="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                    <span>Certificato SSL incluso</span>
                  </li>
                  <li class="flex items-center text-gray-700">
                    <Check class="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                    <span>Backup automatici</span>
                  </li>
                  <li class="flex items-center text-gray-700">
                    <Check class="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                    <span>Supporto tecnico continuo</span>
                  </li>
                  <li class="flex items-center text-gray-700">
                    <Check class="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                    <span>Aggiornamenti di sicurezza</span>
                  </li>
                  <li class="flex items-center text-gray-700">
                    <Check class="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                    <span>Formazione iniziale inclusa</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="mt-8 text-center relative z-10">
              <router-link 
                to="/contact" 
                class="group relative inline-flex items-center h-16 px-10 bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white rounded-2xl font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-2xl animate-bounce-subtle"
              >
                <Rocket class="mr-3 h-6 w-6" />
                <span>🔥 BLOCCA IL TUO POSTO ORA</span>
              </router-link>
              <p class="mt-4 text-gray-600 text-sm font-semibold">
                ⚡ Solo 3 posti rimasti • Prezzo aumenta il 1° gennaio 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Why Choose Us Section -->
    <section class="relative py-20 bg-gradient-to-br from-white via-teal-50/30 to-white overflow-hidden">
      <div class="absolute inset-0">
        <div class="absolute top-0 left-0 w-64 h-64 bg-teal-400/10 rounded-full blur-3xl animate-float"></div>
        <div class="absolute bottom-0 right-0 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl animate-float-delayed"></div>
      </div>
      
      <div class="container mx-auto px-4 relative z-10">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold mb-6">
            <span class="bg-gradient-to-r from-teal-600 via-teal-500 to-cyan-600 bg-clip-text text-transparent">
              Perché Sceglierci
            </span>
          </h2>
          <p class="text-xl text-gray-600 max-w-3xl mx-auto">
            Siamo specializzati in soluzioni digitali per il settore sanitario
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div class="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-300 shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-center">
            <div class="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform">
              <Users class="h-8 w-8 text-white" />
            </div>
            <h3 class="text-xl font-bold mb-3 text-gray-800">Esperienza Healthcare</h3>
            <p class="text-gray-600">Anni di esperienza con studi medici e fisioterapisti in Svizzera</p>
          </div>

          <div class="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-300 shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-center">
            <div class="w-16 h-16 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform">
              <Shield class="h-8 w-8 text-white" />
            </div>
            <h3 class="text-xl font-bold mb-3 text-gray-800">Conformità GDPR</h3>
            <p class="text-gray-600">Dati dei pazienti protetti secondo le normative svizzere ed europee</p>
          </div>

          <div class="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-300 shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-center">
            <div class="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform">
              <Clock class="h-8 w-8 text-white" />
            </div>
            <h3 class="text-xl font-bold mb-3 text-gray-800">Supporto Rapido</h3>
            <p class="text-gray-600">Assistenza in italiano con risposta entro 24 ore</p>
          </div>

          <div class="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-300 shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-center">
            <div class="w-16 h-16 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform">
              <Zap class="h-8 w-8 text-white" />
            </div>
            <h3 class="text-xl font-bold mb-3 text-gray-800">Consegna Veloce</h3>
            <p class="text-gray-600">Il tuo sito online in sole 2-3 settimane</p>
          </div>
        </div>
      </div>
    </section>

    <!-- How It Works Section -->
    <section class="relative py-20 bg-gradient-to-br from-gray-50 via-white to-teal-50/30 overflow-hidden">
      <div class="container mx-auto px-4 relative z-10">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold mb-6">
            <span class="bg-gradient-to-r from-teal-600 via-teal-500 to-cyan-600 bg-clip-text text-transparent">
              Come Funziona
            </span>
          </h2>
          <p class="text-xl text-gray-600 max-w-3xl mx-auto">
            Un processo semplice e trasparente in 4 step
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div class="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-300 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 text-center">
            <div class="w-20 h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6 text-white font-bold text-3xl shadow-xl group-hover:scale-110 transition-transform">
              1
            </div>
            <h3 class="text-xl font-bold mb-4 text-gray-800">Consulenza Gratuita</h3>
            <p class="text-gray-600">Analizziamo insieme le tue esigenze e ti mostriamo una demo del sistema</p>
          </div>

          <div class="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-300 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 text-center">
            <div class="w-20 h-20 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-6 text-white font-bold text-3xl shadow-xl group-hover:scale-110 transition-transform">
              2
            </div>
            <h3 class="text-xl font-bold mb-4 text-gray-800">Personalizzazione</h3>
            <p class="text-gray-600">Creiamo il sito con i tuoi colori, logo e contenuti specifici</p>
          </div>

          <div class="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-300 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 text-center">
            <div class="w-20 h-20 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-2xl flex items-center justify-center mx-auto mb-6 text-white font-bold text-3xl shadow-xl group-hover:scale-110 transition-transform">
              3
            </div>
            <h3 class="text-xl font-bold mb-4 text-gray-800">Formazione</h3>
            <p class="text-gray-600">Ti insegniamo a usare il gestionale in una sessione dedicata</p>
          </div>

          <div class="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-300 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 text-center">
            <div class="w-20 h-20 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-6 text-white font-bold text-3xl shadow-xl group-hover:scale-110 transition-transform">
              4
            </div>
            <h3 class="text-xl font-bold mb-4 text-gray-800">Go Live!</h3>
            <p class="text-gray-600">Il tuo sito è online e il gestionale pronto all'uso</p>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Section -->
    <section class="relative py-20 bg-gradient-to-br from-white via-gray-50 to-teal-50/30 overflow-hidden">
      <div class="container mx-auto px-4 relative z-10">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold mb-6">
            <span class="bg-gradient-to-r from-teal-600 via-teal-500 to-cyan-600 bg-clip-text text-transparent">
              Domande Frequenti
            </span>
          </h2>
        </div>

        <div class="max-w-4xl mx-auto space-y-4">
          <div v-for="(faq, index) in faqs" :key="index" class="bg-white/80 backdrop-blur-sm rounded-xl shadow-md border border-gray-200 overflow-hidden">
            <button 
              @click="toggleFaq(index)"
              class="w-full flex justify-between items-center p-6 text-left hover:bg-gray-50 transition-colors"
            >
              <h3 class="text-lg font-bold text-gray-800 pr-4">{{ faq.question }}</h3>
              <ChevronDown 
                class="h-5 w-5 text-gray-600 flex-shrink-0 transition-transform duration-300"
                :class="{ 'rotate-180': activeFaq === index }"
              />
            </button>
            <div v-show="activeFaq === index" class="px-6 pb-6">
              <p class="text-gray-600 leading-relaxed">{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Final CTA Section - MAXIMUM URGENCY -->
    <section class="relative py-20 bg-gradient-to-br from-red-600 via-red-700 to-orange-600 overflow-hidden">
      <div class="absolute inset-0">
        <div class="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        <div class="absolute bottom-0 left-0 w-96 h-96 bg-orange-400/10 rounded-full blur-3xl"></div>
      </div>
      
      <div class="container mx-auto px-4 text-center relative z-10">
        <div class="max-w-4xl mx-auto">
          <!-- Countdown in CTA -->
          <div class="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-8 border border-white/20">
            <div class="text-white/80 text-sm font-semibold mb-3">⏰ L'OFFERTA SCADE TRA:</div>
            <div class="flex justify-center gap-3 mb-4">
              <div class="bg-white/20 rounded-lg px-4 py-3 text-center min-w-[70px]">
                <div class="text-3xl font-extrabold text-white leading-none">{{ countdown.days }}</div>
                <div class="text-xs uppercase text-white/70">giorni</div>
              </div>
              <div class="bg-white/20 rounded-lg px-4 py-3 text-center min-w-[70px]">
                <div class="text-3xl font-extrabold text-white leading-none">{{ countdown.hours }}</div>
                <div class="text-xs uppercase text-white/70">ore</div>
              </div>
              <div class="bg-white/20 rounded-lg px-4 py-3 text-center min-w-[70px]">
                <div class="text-3xl font-extrabold text-white leading-none">{{ countdown.minutes }}</div>
                <div class="text-xs uppercase text-white/70">minuti</div>
              </div>
              <div class="bg-white/20 rounded-lg px-4 py-3 text-center min-w-[70px] animate-pulse">
                <div class="text-3xl font-extrabold text-yellow-300 leading-none">{{ countdown.seconds }}</div>
                <div class="text-xs uppercase text-white/70">secondi</div>
              </div>
            </div>
            <div class="flex items-center justify-center gap-2 text-yellow-300 font-bold">
              <AlertTriangle class="h-5 w-5" />
              <span>Dopo questa data il prezzo sale a 5'000 CHF!</span>
            </div>
          </div>
          
          <div class="inline-flex items-center rounded-full bg-yellow-400 text-red-700 px-6 py-3 text-sm font-extrabold mb-6 shadow-lg">
            <span class="flex h-3 w-3 rounded-full bg-red-600 mr-2 animate-ping"></span>
            🔥 ULTIMI 3 POSTI A QUESTO PREZZO SPECIALE!
          </div>
          
          <h2 class="text-4xl md:text-5xl font-extrabold text-white mb-4">
            Non Perdere Questa Opportunità!
          </h2>
          <p class="text-xl md:text-2xl mb-8 text-white/90 font-semibold max-w-3xl mx-auto">
            Risparmi <span class="text-yellow-300 underline">2'180 CHF</span> se agisci ora. Il prezzo tornerà a 5'000 CHF dal 1° Gennaio 2026.
          </p>
          
          <div class="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <router-link 
              to="/contact" 
              class="group relative h-20 px-12 bg-yellow-400 hover:bg-yellow-300 text-red-700 rounded-2xl inline-flex items-center justify-center font-extrabold text-xl transition-all duration-300 transform hover:scale-110 shadow-2xl animate-bounce-subtle"
            >
              <Rocket class="mr-3 h-7 w-7" />
              <span>SÌ! VOGLIO BLOCCARE IL MIO POSTO</span>
            </router-link>
          </div>
          
          <div class="flex flex-wrap justify-center gap-6 text-sm text-white">
            <div class="flex items-center bg-white/10 rounded-full px-4 py-2">
              <Check class="h-5 w-5 text-green-300 mr-2" />
              Garanzia soddisfatto o rimborsato
            </div>
            <div class="flex items-center bg-white/10 rounded-full px-4 py-2">
              <Check class="h-5 w-5 text-green-300 mr-2" />
              Nessun rischio
            </div>
            <div class="flex items-center bg-white/10 rounded-full px-4 py-2">
              <Check class="h-5 w-5 text-green-300 mr-2" />
              Supporto dedicato
            </div>
          </div>
          
          <p class="mt-6 text-white/60 text-sm">
            ⚠️ Attenzione: una volta esauriti i 3 posti, l'offerta non sarà più disponibile.
          </p>
        </div>
      </div>
    </section>
    
    <FloatingCta />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { 
  Phone,
  Check, 
  Star,
  Heart,
  Users,
  Shield, 
  Clock,
  Zap,
  Globe,
  Settings,
  Rocket,
  ChevronDown,
  AlertTriangle
} from 'lucide-vue-next'
import FloatingCta from '../components/FloatingCta.vue'

const activeFaq = ref(null)

// Countdown to end of 2025
const countdown = reactive({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0
})

let countdownInterval = null

const updateCountdown = () => {
  const endDate = new Date('2025-12-31T23:59:59')
  const now = new Date()
  const diff = endDate - now

  if (diff > 0) {
    countdown.days = Math.floor(diff / (1000 * 60 * 60 * 24))
    countdown.hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    countdown.minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    countdown.seconds = Math.floor((diff % (1000 * 60)) / 1000)
  } else {
    countdown.days = 0
    countdown.hours = 0
    countdown.minutes = 0
    countdown.seconds = 0
  }
}

onMounted(() => {
  updateCountdown()
  countdownInterval = setInterval(updateCountdown, 1000)
})

onUnmounted(() => {
  if (countdownInterval) {
    clearInterval(countdownInterval)
  }
})

const faqs = [
  {
    question: "Quanto tempo ci vuole per avere il sito e il gestionale pronti?",
    answer: "Il tempo di consegna standard è di 2-3 settimane dalla conferma dell'ordine. Questo include la personalizzazione del sito con i tuoi contenuti, la configurazione del gestionale e la sessione di formazione."
  },
  {
    question: "Posso provare il gestionale prima di acquistare?",
    answer: "Certamente! Offriamo una demo gratuita e senza impegno dove potrai vedere tutte le funzionalità del sistema e fare domande. Contattaci ora."
  },
  {
    question: "I dati dei miei pazienti sono al sicuro?",
    answer: "Assolutamente. Utilizziamo hosting svizzero con crittografia SSL, backup automatici giornalieri e siamo conformi alle normative GDPR e alle leggi svizzere sulla protezione dei dati sanitari."
  },
  {
    question: "Cosa include la manutenzione mensile da 10 CHF?",
    answer: "Il canone mensile include: hosting su server svizzeri, certificato SSL, backup automatici, aggiornamenti di sicurezza, supporto tecnico via email e telefono, e piccole modifiche al sito."
  },
  {
    question: "Posso gestire gli appuntamenti dal telefono?",
    answer: "Sì! Il sistema gestionale è completamente responsive e funziona perfettamente su smartphone e tablet. Puoi gestire appuntamenti, consultare schede pazienti e inviare promemoria ovunque tu sia."
  },
  {
    question: "È possibile integrare il sistema con altri software che già uso?",
    answer: "Dipende dal software. Contattaci per discutere le tue esigenze specifiche e valuteremo insieme le possibilità di integrazione con i tuoi strumenti attuali."
  },
  {
    question: "Cosa succede se ho bisogno di modifiche al sito dopo la consegna?",
    answer: "Piccole modifiche sono incluse nel canone di manutenzione mensile. Per modifiche più sostanziali o nuove funzionalità, ti forniremo un preventivo dedicato."
  },
  {
    question: "Posso disdire il servizio quando voglio?",
    answer: "Sì, non ci sono vincoli contrattuali a lungo termine. Puoi disdire il servizio di hosting e manutenzione con un preavviso di 30 giorni. Il sito web resta di tua proprietà."
  }
]

const toggleFaq = (index) => {
  activeFaq.value = activeFaq.value === index ? null : index
}

defineOptions({
  name: 'SitiWebFisioterapiaPage'
})
</script>

<style scoped>
@keyframes gradient {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) translateX(0px);
  }
  50% {
    transform: translateY(-20px) translateX(10px);
  }
}

@keyframes grid {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

@keyframes bounce-subtle {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.animate-gradient {
  background-size: 200% 200%;
  animation: gradient 15s ease infinite;
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-float-delayed {
  animation: float 8s ease-in-out infinite;
  animation-delay: 2s;
}

.animate-grid {
  animation: grid 20s linear infinite;
}

.animate-pulse-slow {
  animation: pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-bounce-subtle {
  animation: bounce-subtle 2s ease-in-out infinite;
}
</style>

